import { format } from "date-fns";
import { axiosApiInstance } from "./axios";
import { axiosAuthInstance, axiosAuthInstanceForFormData } from "./axiosAuth";
import { createApiError } from "./apiErrorHandler";
import logger from "../utils/logger";

const base_url = import.meta.env.VITE_API_ENDPOINT;

export const getCustomerByIccid = async (iccid) => {
  try {
    const url = `${base_url}/app/customer/iccid`;
    const { data } = await axiosAuthInstance.post(url, { iccid });
    return data;
  } catch (ex) {
    return createApiError(ex, "getCustomerByIccid");
  }
};

// Alias — both functions hit the same endpoint (/app/customer/iccid)
export const getCustomerByMsisdn = getCustomerByIccid;

export const formatMsisdn = async (msisdn) => {
  try {
    const url = `${base_url}/app/formatmsisdn`;
    const { data } = await axiosApiInstance.post(url, { msisdn });
    return data;
  } catch (ex) {
    return createApiError(ex, "formatMsisdn");
  }
};

export const formatWhatsappMsisdn = async (msisdn) => {
  try {
    const url = `${base_url}/app/format-whatsapp-msisdn`;
    const { data } = await axiosApiInstance.post(url, { msisdn });
    return data;
  } catch (ex) {
    return createApiError(ex, "formatWhatsappMsisdn");
  }
};
export const sendOtp = async (username) => {
  try {
    const url = `${base_url}/app/password/otp`;
    const { data } = await axiosApiInstance.post(url, { email_address: username });
    return data;
  } catch (ex) {
    return createApiError(ex, "sendOtp");
  }
};

export const sendOtpWithMsisdn = async (msisdn) => {
  try {
    const url = `${base_url}/app/password/msisdn/otp`;
    const { data } = await axiosApiInstance.post(url, { msisdn });
    return data;
  } catch (ex) {
    return createApiError(ex, "sendOtpWithMsisdn");
  }
};

export const sendOtpIdNumber = async (idNumber) => {
  try {
    const url = `${base_url}/app/password/id_number/otp`;
    const { data } = await axiosApiInstance.post(url, { id_number: idNumber });
    return data;
  } catch (ex) {
    return createApiError(ex, "sendOtpIdNumber");
  }
};

export const resetPassword = async (data) => {
  try {
    const url = `${base_url}/app/password/reset`;
    const { data: response } = await axiosApiInstance.post(url, data);

    if (response.status_code !== 1001) {
    }
    return response;
  } catch (ex) {
    return createApiError(ex, "resetPassword");
  }
};

export const resetPasswordByIdNumber = async (data) => {
  try {
    const url = `${base_url}/app/password/reset-by-id-number`;
    const { data: response } = await axiosApiInstance.post(url, data);

    if (response.status_code !== 1001) {
    }
    return response;
  } catch (ex) {
    return createApiError(ex, "resetPasswordByIdNumber");
  }
};

export const addDistributorLead = async (data) => {
  if (data.school_registration_type === "Public School") {
    data.company_name = data.school_name;
    data.company_registration_number = data.school_emis;
    data.company_registered_name = data.school_name;
    data.company_address_unit_block = data.school_address_unit_block;
    data.company_address_street_name_number = data.school_address_street_name_number;
    data.company_suburb = data.school_suburb;
    data.company_city = data.school_city;
    data.company_province = data.school_province;
    data.company_postal_code = data.school_postal_code;
  }

  // format all the phone numbers
  const school_principal_phone_number = await formatMsisdn(data.school_principal_phone_number);
  if (school_principal_phone_number?.error || school_principal_phone_number.data === null) {
    return { status_code: 9000, data: "Invalid school principal phone number" };
  }
  data.school_principal_phone_number = school_principal_phone_number.data;

  const school_contact_phone_number = await formatMsisdn(data.school_contact_phone_number);
  if (school_contact_phone_number?.error || school_contact_phone_number.data === null) {
    return { status_code: 9000, data: "Invalid school contact phone number" };
  }

  data.school_contact_phone_number = school_contact_phone_number.data;
  const school_finance_person_phone_number = await formatMsisdn(data.school_finance_person_phone_number);
  if (school_finance_person_phone_number?.error || school_finance_person_phone_number.data === null) {
    return { status_code: 9000, data: "Invalid school finance person phone number" };
  }
  data.school_finance_person_phone_number = school_finance_person_phone_number.data;

  try {
    const url = `${base_url}/app/distributor/leads/add`;
    // const url = `${base_url}/app/distributor/schools/add-lead`;
    const { data: response } = await axiosApiInstance.post(url, data);

    if (response.status_code !== 1001) {
    }
    return response;
  } catch (ex) {
    return createApiError(ex, "addDistributorLead");
  }
};

export const addDistributorSimOrder = async (data, distributorDetails) => {
  try {
    const post_data = {
      distributor_name: distributorDetails.company_name,
      order_status: "Account Manager",
      order_client_id: distributorDetails.monday_id,
      order_person: "45002791",
      order_description: data.item.description,
      order_quantity: data.item.quantity,
      order_price_ex_vat: data.item.price,
      order_value: data.item.total,
    };

    const url = `${base_url}/app/monday/distribution/sim/order`;
    const { data: response } = await axiosAuthInstance.post(url, post_data);


    return response;
  } catch (ex) {
    return createApiError(ex, "addDistributorSimOrder");
  }
};

export const addDistributorStore = async (formData) => {

  // Transform the form data to match the API's expected format
  const transformedData = {
    i_customer: formData.i_customer,
    name: formData.distributor_name,
    external_id: formData.distributor_external_id,
    phone_number: formData.distributor_phone,
    email_address: formData.distributor_email,
  };

  try {
    const url = `${base_url}/app/distributor/store/add`;
    const { data: response } = await axiosAuthInstance.post(url, transformedData);

    if (response.status_code !== 1001) {
      // Handle error
    }
    return response;
  } catch (ex) {
    return createApiError(ex, "addDistributorStore");
  }
};

export const verifyEmailAddress = async (email_address) => {
  try {
    const url = `${base_url}/app/email/verify`;
    const { data } = await axiosApiInstance.post(url, { email_address });
    return data;
  } catch (ex) {
    return createApiError(ex, "verifyEmailAddress");
  }
};

export const getDistributorTransactionHistory = async (i_customer, start_date, end_date, distributor_subdistributor_id) => {
  /*
  {
    "i_customer": 1574,
    "start_date": "2023-08-01 00:00:00",
    "end_date": "2023-09-01 00:00:00",
    "distributor_subdistributor_id" : 12
  }

  const date = new Date('2022-08-31T22:00:00.000Z');
const dateString = date.toISOString().replace('T', ' ').replace(/\.\d{3}Z/, '');
logger.debug(dateString); // Output: 2022-08-31 22:00:00
  */

  const post_data = {
    distributor_i_customer: i_customer,
    start_date,
    end_date,
  };

  if (distributor_subdistributor_id) {
    post_data.sub_distributor_id = distributor_subdistributor_id;
  }
  try {
    const url = `${base_url}/app/distributor/transactions`;
    const { data } = await axiosAuthInstance.post(url, post_data);
    logger.debug("getDistributorTransactionHistory", data);
    return data;
  } catch (ex) {
    return createApiError(ex, "getDistributorTransactionHistory");
  }
};

export const getResellerTransactionHistory = async (i_customer, start_date, end_date) => {
  const post_data = {
    distributor_i_customer: i_customer,
    start_date: start_date
      .toISOString()
      .replace("T", " ")
      .replace(/\.\d{3}Z/, ""),
    end_date: end_date
      .toISOString()
      .replace("T", " ")
      .replace(/\.\d{3}Z/, ""),
  };

  try {
    const url = `${base_url}/app/reseller/transactions`;
    const { data } = await axiosAuthInstance.post(url, post_data);
    return data;
  } catch (ex) {
    return createApiError(ex, "getResellerTransactionHistory");
  }
};

export const getResellerProducts = async (network, category) => {
  try {
    const url = `${base_url}/app/var/pinless/bundle/?network=${network}&category=${category}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getResellerProducts");
  }
};

export const getDistributorProducts = async (distributor_i_customer, product_type_id) => {
  try {
    const url = `${base_url}/app/distributor/products?distributor_i_customer=${distributor_i_customer}&product_type_id=${product_type_id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getDistributorProducts");
  }
};

export const getResellerCategories = async (network) => {
  try {
    const url = `${base_url}/app/var/pinless/categories/?network=${network}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getResellerCategories");
  }
};

export const processResellerSale = async (payload) => {
  try {
    const url = `${base_url}/app/var/pinless/airtime/sale`;
    const { data } = await axiosAuthInstance.post(url, payload);

    return data;
  } catch (ex) {
    return createApiError(ex, "processResellerSale");
  }
};

export const processResellerDataSale = async (payload) => {
  try {
    const url = `${base_url}/app/var/pinless/data/sale`;
    const { data } = await axiosAuthInstance.post(url, payload);

    return data;
  } catch (ex) {
    return createApiError(ex, "processResellerDataSale");
  }
};

export const addCustomerLead = async (payload) => {
  try {
    const url = `${base_url}/app/customer/leads`;
    const { data } = await axiosAuthInstance.post(url, payload);
    return data;
  } catch (ex) {
    return createApiError(ex, "addCustomerLead");
  }
};

export const verifySimCard = async (iccid) => {
  try {
    const url = `${base_url}/app/sim_card/verify/sale`;
    const { data } = await axiosAuthInstance.post(url, { iccid });
    return data;
  } catch (ex) {
    return createApiError(ex, "verifySimCard");
  }
};

export const validateID = async (id_number, username) => {
  try {
    const url = `${base_url}/app/customer/rica/id`;
    const { data } = await axiosAuthInstance.post(url, { id_number, username });
    return data;
  } catch (ex) {
    return createApiError(ex, "validateID");
  }
};

export const getIdentity = async (id_number) => {
  try {
    const url = `${base_url}/app/customer/rica/identity`;
    const { data } = await axiosAuthInstance.post(url, { id_number });
    return data;
  } catch (ex) {
    return createApiError(ex, "getIdentity");
  }
};

export const validatePostalCode = async (postal_code) => {
  try {
    const url = `${base_url}/app/customer/verify/postalcode`;
    const { data } = await axiosAuthInstance.post(url, { postal_code });
    return data;
  } catch (ex) {
    return createApiError(ex, "validatePostalCode");
  }
};

export const addCustomerDetails = async (values) => {
  try {
    let { id_number } = values;
    if (values.id_type === "2" || values.id_type === "3") {
      id_number = values.passport_number;
    }

    // if values.msisdn is an oject we need to concatenate the countryCode, areaCode and phoneNumber
    if (values?.msisdn && typeof values?.msisdn === "object") {
      // check that the keys are countryCode, areaCode, phoneNumber
      if (values?.msisdn?.countryCode && values?.msisdn?.areaCode && values?.msisdn?.phoneNumber) {
        values.msisdn = `${values?.msisdn?.countryCode}${values?.msisdn?.areaCode}${values?.msisdn?.phoneNumber}`;
      }
    }

    // if alt_phone_number is an object and the keys are countryCode, areaCode, phoneNumber
    if (values?.alt_phone_number && typeof values?.alt_phone_number === "object") {
      // check that the keys are countryCode, areaCode, phoneNumber
      if (values?.alt_phone_number?.countryCode && values?.alt_phone_number?.areaCode && values?.alt_phone_number?.phoneNumber) {
        values.alt_phone_number = `${values?.alt_phone_number?.countryCode}${values?.alt_phone_number?.areaCode}${values?.alt_phone_number?.phoneNumber}`;
      }
    }

    if (values?.whatsapp_msisdn && typeof values?.whatsapp_msisdn === "object") {
      values.whatsapp_msisdn = `${values?.whatsapp_msisdn?.countryCode}${values?.whatsapp_msisdn?.areaCode}${values?.whatsapp_msisdn?.phoneNumber}`;
    }


    const post_data = {
      distributor_i_customer: values.distributor_i_customer,
      id_number,
      id_url: "",
      id_type: values.id_type,
      nationality: values.citizenship,
      first_name: values.first_name,
      last_name: values.last_name,
      phone_number: values.msisdn,
      whatsapp_msisdn: values.whatsapp_msisdn,
      alt_phone_number: values.alt_phone_number,
      email: values.email,
      gender: values.gender,
      language: values.language,
      date_of_birth: format(new Date(values.date_of_birth), "yyyy-MM-dd"),
      address_1: values.address_1 ?? "22 Karee Street",
      address_2: values.address_2 ?? "Centurion",
      city: values.city ?? "Pretoria",
      province: values.province ?? 3,
      zip: values.postal_code ?? "0062",
      sim_serial_number: values.iccid,
      payment_type: "cash",
      port: false,
      self_rica: false,
      self_rica_channel: values.self_rica_channel,
      rica_agent: values.rica_agent,
      port_network: "",
      external_id: values.external_id,
      address_valid: true,
      photo_valid: values.photo_valid,
      portal_selfie: values.portal_selfie,
    };

    // return {status_code: 1001, data: 'Success!'}
    // return {status_code: 9001, data: 'Please provide a MSISDN and network for porting'}
    // return {status_code: 9002, data: 'You do not have sufficient funds to process the transaction, please top up your trader wallet'}
    // return {status_code: 9003, data: 'Error connecting to RICA, please submit again'}
    // return {status_code: 9004, data: 'SIM Card has already been RICAd, please use another SIM card'}
    // return {status_code: 9005, data: 'Error with customer data: Error. Please update the customer fields and submit again'}
    // return {status_code: 9006, data: 'Error connecting to RICA, please submit again. If the issue persists, please contact support'}
    // return {status_code: 9007, data: 'Error creating the Customer in PortaOne, please submit again. If the issue persists, please contact support'}

    logger.debug("Calling API with: ", { post_data });
    const url = `${base_url}/app/customer/add/details`;
    const { data } = await axiosAuthInstance.post(url, post_data, { timeout: 120000 });

    return data;
    // return { status_code: 1001, data: "Success!" };
  } catch (ex) {
    return createApiError(ex, "addCustomerDetails");
  }
};

export const formatICCID = async (iccid) => {
  try {
    const url = `${base_url}/app/sim_card/iccid/format`;
    const { data } = await axiosAuthInstance.post(url, { iccid });
    return data;
  } catch (ex) {
    return createApiError(ex, "formatICCID");
  }
};

export const getDistributorSimCards = async (distributor_i_customer, page, rowsPerPage, search, sub_distributor_id) => {
  try {
    const url = `${base_url}/app/sim_card/list-sims`;
    const { data } = await axiosAuthInstance.post(
      url,
      distributor_i_customer === "All"
        ? { limit: rowsPerPage, page: page + 1, search }
        : sub_distributor_id
          ? { distributor_i_customer, limit: rowsPerPage, page: page + 1, search, sub_distributor_id }
          : { distributor_i_customer, limit: rowsPerPage, page: page + 1, search }
    );
    return data;
  } catch (ex) {
    return createApiError(ex, "getDistributorSimCards");
  }
};

export const getDistributorScanOutRequests = async (distributor_i_customer, sub_distributor_id = null) => {
  try {
    logger.debug(`Calling the API with distributor_i_customer: ${distributor_i_customer} and sub_distributor_id: ${sub_distributor_id}`);
    const url = `${base_url}/app/sim_card/list-scan-out-requests`;
    // make a get request to the url with params
    const { data } = await axiosAuthInstance.post(url, {
      distributor_i_customer,
      sub_distributor_id,
    });
    return data;
  } catch (ex) {
    return createApiError(ex, "getDistributorScanOutRequests");
  }
};

export const submitDistributorSIMScanOutRequest = async ({
  distributor_i_customer,
  sub_distributor_id,
  serial_number,
  box_type,
  brand_sticker_file,
  mtn_sticker_file,
}) => {
  try {
    const url = `${base_url}/app/sim_card/submit-scan-out-request`;
    logger.debug({ distributor_i_customer, sub_distributor_id, serial_number, box_type, brand_sticker_file, mtn_sticker_file });
    const { data } = await axiosAuthInstanceForFormData.post(url, {
      distributor_i_customer,
      sub_distributor_id,
      serial_number,
      box_type,
      brand_sticker_file,
      mtn_sticker_file,
    });
    logger.debug({ data });
    return data;
  } catch (ex) {
    return createApiError(ex, "submitDistributorSIMScanOutRequest");
  }
};

export const getSimCardProducts = async () => {
  try {
    const url = `${base_url}/app/distributor/sim_card_order/products`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getSimCardProducts");
  }
};

export const orderSimCardsInvoice = async (simCardData) => {
  try {
    const url = `${base_url}/app/distributor/sim_card_order`;
    const { data } = await axiosAuthInstance.post(url, simCardData);
    return data;
  } catch (ex) {
    return createApiError(ex, "orderSimCardsInvoice");
  }
};

export const updateSoftBlockStatus = async (i_customer, action) => {
  try {
    const url = `${base_url}/app/customer/update-soft-block-status`;
    const { data } = await axiosAuthInstance.post(url, { i_customer, action });
    return data;
  } catch (ex) {
    return createApiError(ex, "updateSoftBlockStatus");
  }
};

export const getSoftBlockHistory = async (i_customer) => {
  try {
    const url = `${base_url}/app/customer/soft-block/history`;
    const { data } = await axiosAuthInstance.get(url, { params: { i_customer } });
    return data;
  } catch (ex) {
    return createApiError(ex, "getSoftBlockHistory");
  }
};

export const suspendCustomer = async (i_customer) => {
  try {
    const url = `${base_url}/app/customer/suspend`;
    const { data } = await axiosAuthInstance.post(url, { i_customer });
    return data;
  } catch (ex) {
    return createApiError(ex, "suspendCustomer");
  }
};

export const unsuspendCustomer = async (i_customer) => {
  try {
    const url = `${base_url}/app/customer/unsuspend`;
    const { data } = await axiosAuthInstance.post(url, { i_customer });
    return data;
  } catch (ex) {
    return createApiError(ex, "unsuspendCustomer");
  }
};

export const resendOTP = async (msisdn) => {
  try {
    const url = `${base_url}/customer/password/otp`;
    const { data } = await axiosAuthInstance.post(url, { msisdn });
    return data;
  } catch (ex) {
    return createApiError(ex, "resendOTP");
  }
};

export const resetAppPassword = async (i_customer) => {
  try {
    const url = `${base_url}/app/password/reset-customer-password`;
    const { data } = await axiosAuthInstance.post(url, { i_customer });
    return data;
  } catch (ex) {
    return createApiError(ex, "resetAppPassword");
  }
};

export const updateCustomerDisplayName = async (i_customer, display_name) => {
  try {
    const url = `${base_url}/app/customer/update-display-name`;
    const { data } = await axiosAuthInstance.post(url, { i_customer, display_name });
    return data;
  } catch (ex) {
    return createApiError(ex, "updateCustomerDisplayName");
  }
};

export const topUpCustomer = async (msisdn, data_value, airtime_value, wallet_value, reason, portal_user, type) => {
  try {
    const url = `${base_url}/app/cc/manual_top_up`;
    const { data } = await axiosAuthInstance.post(url, { msisdn, data_value, airtime_value, wallet_value, reason, portal_user, type });
    return data;
  } catch (ex) {
    return createApiError(ex, "topUpCustomer");
  }
};

export const getVoucherDetails = async (code) => {
  try {
    const url = `${base_url}/app/voucher/info`;
    const { data } = await axiosAuthInstance.post(url, { code });
    return data;
  } catch (ex) {
    return createApiError(ex, "getVoucherDetails");
  }
};

export const getVoucherList = async (page = 1, limit = 25, search, filterStatus, filterService, filterStartDate, filterEndDate, distributor_i_customer) => {

  try {
    const url = `${base_url}/app/voucher/list`;
    // distributor_i_customer === "All" ? { limit: rowsPerPage, page: page + 1 } : { distributor_i_customer, limit: rowsPerPage, page: page + 1 }
    const { data } = await axiosAuthInstance.post(
      url,
      distributor_i_customer === "All"
        ? {
            page,
            limit,
            search,
            filterStatus,
            filterService,
            filterStartDate,
            filterEndDate,
          }
        : {
            page,
            limit,
            search,
            filterStatus,
            filterService,
            filterStartDate,
            filterEndDate,
            distributor_i_customer,
          }
    );
    return data;
  } catch (ex) {
    return createApiError(ex, "getVoucherList");
  }
};

export const getBrands = async () => {
  try {
    const url = `${base_url}/app/distributor/brands`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getBrands");
  }
};

export const getBrandByDomain = async (domain) => {
  try {
    const url = `${base_url}/app/distributor/brand-info/?domain=${domain}`;
    const { data } = await axiosAuthInstance.get(url, { domain });
    return data;
  } catch (ex) {
    return createApiError(ex, "getBrandByDomain");
  }
};

export const getSIMCardDetails = async (iccid) => {
  try {
    const url = `${base_url}/app/sim_card/details`;
    const { data } = await axiosAuthInstance.post(url, { iccid });
    return data;
  } catch (ex) {
    return createApiError(ex, "getSIMCardDetails");
  }
};

export const addAppUser = async (data) => {
  const post_data = {
    list: [data],
  };
  try {
    const url = `${base_url}/app/user/add`;
    const { data: response } = await axiosAuthInstance.post(url, post_data);
    return response;
  } catch (ex) {
    return createApiError(ex, "addAppUser");
  }
};

// export const listAppUsers = async (distributor_i_customer) => {
//   try {
//     const url = `${base_url}/app/user/list`;
//     const { data } = await axiosAuthInstance.post(url, { distributor_i_customer });
//     return data;
//   } catch (ex) {
// //   }
// };

export const getESim = async (distributor_i_customer, activation_id) => {
  try {
    const url = `${base_url}/app/eSIM/getSimCard?distributor_i_customer=${distributor_i_customer}&activation_id=${activation_id}`;
    const { data } = await axiosAuthInstance.get(url);

    return data;
  } catch (ex) {
    return createApiError(ex, "getESim");
  }
};

export const getESimCount = async (distributor_i_customer) => {
  try {
    const url = `${base_url}/app/eSIM/get-esims-count?distributor_i_customer=${distributor_i_customer}`;

    const { data } = await axiosAuthInstance.get(url);

    return data;
    // return {
    //   "status_code": 1001,
    //   "data": [
    //     {
    //       "activation_id": 66,
    //       "description": "eSIM R9 for 3GB - 7 Day",
    //       "count": 750
    //     },
    //     {
    //       "activation_id": 67,
    //       "description": "eSIM R99 for 10GB - 7 Day",
    //       "count": 375
    //     },
    //     {
    //       "activation_id": 68,
    //       "description": "eSIM R199 for 25GB - 30 Day",
    //       "count": 125
    //     }
    //   ]
    // }
  } catch (ex) {
    return createApiError(ex, "getESimCount");
  }
};

export const getAppUserDetails = async (id) => {
  try {
    const url = `${base_url}/app/user?id=${id}`;
    const { data } = await axiosAuthInstance.get(url);
    const userRoles = data?.data?.roles?.map((role) => ({
      label: role.role === "distributor" ? "Distributor" : role.role === "sub-distributor" ? "Sub Distributor" : role.role === "admin" ? "Admin" : role.role,
      value: role.role,
    }));
    data.data.distributor_i_customer = data?.data?.roles?.[0]?.i_customer;
    data.data.roles = userRoles;

    return data;
  } catch (ex) {
    return createApiError(ex, "getAppUserDetails");
  }
};

export const getAppUserDistributors = async (id) => {
  try {
    const url = `${base_url}/app/user-roles?id=${id}`;
    const { data } = await axiosAuthInstance.get(url);
    // const userRoles = data?.data?.map((item) => {
    //   item?.roles?.map((role) => ({
    //     label: role === "distributor" ? "Distributor" : role === "sub-distributor" ? "Sub Distributor" : role === "admin" ? "Admin" : role,
    //     value: role,
    //   }));
    //   item.roles = userRoles;
    // });

    return data;
  } catch (ex) {
    return createApiError(ex, "getAppUserDistributors");
  }
};

export const getAppUserDetailsForDistributor = async (id, i_customer) => {
  try {
    const url = `${base_url}/app/user-distributor?id=${id}&distributor_i_customer=${i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    const userRoles = data?.data?.roles?.map((role) => ({
      label: role.role === "distributor" ? "Distributor" : role.role === "sub-distributor" ? "Sub Distributor" : role.role,
      value: role.role,
    }));
    data.data.distributor_i_customer = data?.data?.roles?.[0]?.i_customer;
    data.data.roles = userRoles;

    return data;
  } catch (ex) {
    return createApiError(ex, "getAppUserDetailsForDistributor");
  }
};

export const editAppUserData = async (userData) => {
  // const roleValues = userData.role.map((role) => role.value);
  // const updatedUserData = {
  //   ...userData,
  //   role: roleValues,
  // };

  try {
    const url = `${base_url}/app/user/edit`;
    const { data } = await axiosAuthInstance.post(url, userData);
    return data;
  } catch (ex) {
    return createApiError(ex, "editAppUserData");
  }
};

export const listAdminAppUsers = async () => {
  try {
    const url = `${base_url}/app/admin`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAdminAppUsers");
  }
};

export const getAdminUserDetails = async (id) => {
  try {
    const url = `${base_url}/app/admin/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getAdminUserDetails");
  }
};

export const editAdminUserData = async (id, adminData) => {
  try {
    const url = `${base_url}/app/admin/${id}`;
    const { data } = await axiosAuthInstance.put(url, adminData);
    return data;
  } catch (ex) {
    return createApiError(ex, "editAdminUserData");
  }
};

export const addAdminUser = async (data) => {
  try {
    const url = `${base_url}/app/admin`;
    const { data: response } = await axiosAuthInstance.post(url, data);
    return response;
  } catch (ex) {
    return createApiError(ex, "addAdminUser");
  }
};

export const deleteAdminUser = async (id) => {
  try {
    const url = `${base_url}/app/admin/${id}`;
    const { data } = await axiosAuthInstance.delete(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "deleteAdminUser");
  }
};

export const listAppUsers = async (distributor_i_customer, sub_distributor_id, role) => {
  try {
    let url = "";
    if (distributor_i_customer === "All" || distributor_i_customer === undefined) {
      url = `${base_url}/app/user`;
    } else {
      url = `${base_url}/app/user/?distributor_i_customer=${distributor_i_customer}&role=${role}`;
      if (sub_distributor_id != null && sub_distributor_id !== undefined) {
        url += `&sub_distributor_id=${sub_distributor_id}`;
      }
    }
    const { data } = await axiosAuthInstance.get(url);
    const filteredUsers = data.data.filter(
      (item) =>
        item.role === "distributor" ||
        item.role === "sub-distributor" ||
        item.role === "sub_distributor_manager" ||
        item.role === "sub_distributor_operations" ||
        item.role === "sub_distributor_finance" ||
        item.role === "support_agent" ||
        item.role === "referrer" ||
        item.role === "agent"
    );
    data.data = filteredUsers;
    return data;
  } catch (ex) {
    return createApiError(ex, "listAppUsers");
  }
};

export const checkUserExists = async (email) => {
  try {
    const url = `${base_url}/app/user/${email}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "checkUserExists");
  }
};

export const addAppUserRoles = async (userData) => {
  try {
    const url = `${base_url}/app/user`;
    const { data } = await axiosAuthInstance.post(url, userData);
    return data;
  } catch (ex) {
    return createApiError(ex, "addAppUserRoles");
  }
};

export const deleteAppUserRole = async (id, i_customer, role, sub_distributor_id) => {
  try {
    let url = `${base_url}/app/user/${id}?distributor_i_customer=${i_customer}&role=${role}`;
    if (sub_distributor_id != null && sub_distributor_id !== undefined) {
      url += `&sub_distributor_id=${sub_distributor_id}`;
    }
    const { data } = await axiosAuthInstance.delete(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "deleteAppUserRole");
  }
};

export const listActiveSubscriptions = async (distributor_i_customer) => {
  try {
    let url = "";
    if (distributor_i_customer === "All" || distributor_i_customer === undefined) {
      url = `${base_url}/app/subscription/active`;
    } else {
      url = `${base_url}/app/subscription/active/?distributor_i_customer=${distributor_i_customer}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listActiveSubscriptions");
  }
};

export const downloadActiveSubscriptions = async (distributor_i_customer) => {
  try {
    const url = `${base_url}/app/subscription/download?distributor_i_customer=${distributor_i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "downloadActiveSubscriptions");
  }
};

export const getSubscriptionDetails = async (id) => {
  try {
    const url = `${base_url}/app/subscription/billing/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getSubscriptionDetails");
  }
};

export const getCustomerBalanceData = async (i_customer) => {
  try {
    const url = `${base_url}/app/customer/balance`;
    const { data } = await axiosAuthInstance.post(url, { i_customer });
    return data;
  } catch (ex) {
    return createApiError(ex, "getCustomerBalanceData");
  }
};

export const getCustomerBalanceDetails = async (i_customer) => {
  try {
    const url = `${base_url}/app/customer/balance/wallet`;
    const { data } = await axiosAuthInstance.post(url, { i_customer });
    return data;
  } catch (ex) {
    return createApiError(ex, "getCustomerBalanceDetails");
  }
};

export const getCustomerRewardsSummary = async (i_customer) => {
  try {
    const url = `${base_url}/app/customer/rewards/summary`;
    const { data } = await axiosAuthInstance.post(url, { i_customer });

    if (data.status_code !== 1001) {
      return data;
    }

    // Return the raw data structure from the API
    // Format: { i_customer, spend_limits, rewards: { allocated: {}, pending: {} } }
    return {
      status_code: data.status_code,
      data: data?.data ?? {},
    };
  } catch (ex) {
    return createApiError(ex, "getCustomerRewardsSummary", { i_customer });
  }
};

export const getCustomerRewards = async ({
  i_customer,
  page = 1,
  per_page = 25,
  status,
  reward_source,
  sort_by = "created_at",
  sort_dir = "desc",
} = {}) => {
  try {
    const url = `${base_url}/app/customer/rewards/list`;
    const backendSortBy = sort_by === "allocated_date" ? "allocated_at" : sort_by;
    const payload = {
      page,
      per_page,
      sort_by: backendSortBy,
      sort_dir,
      i_customer,
    };

    if (status) {
      payload.status = status;
    }

    if (reward_source) {
      // Backend now uses `type` for reward source.
      payload.type = reward_source;
    }

    const { data } = await axiosAuthInstance.post(url, payload);

    if (data.status_code !== 1001) {
      return data;
    }

    const responseBody = data?.data ?? {};
    const meta = responseBody?.meta ?? {};

    if (!Array.isArray(responseBody?.data)) {
      return createApiError(new Error("Invalid rewards response shape"), "getCustomerRewards", {
        i_customer,
        page,
        per_page,
        status,
        reward_source,
      });
    }

    const rewardsRaw = responseBody.data;
    const invalidDualLedgerRows = rewardsRaw.filter((row) => {
      const credit = Number(row?.credit ?? 0);
      const debit = Number(row?.debit ?? 0);

      return Number.isFinite(credit) && credit > 0 && Number.isFinite(debit) && debit > 0;
    });

    if (invalidDualLedgerRows.length > 0) {
      logger.warn("Rewards ledger row has both credit and debit values", {
        invalid_row_count: invalidDualLedgerRows.length,
      });
    }

    const validRewardsRaw = invalidDualLedgerRows.length > 0
      ? rewardsRaw.filter((row) => !invalidDualLedgerRows.includes(row))
      : rewardsRaw;

    // Normalize backend fields to what the UI table expects.
    // UI expects: reward_source, reward_value, allocated_date, expires_at, created_at, updated_at, status
    const rewards = validRewardsRaw.map((row) => {
      const rawCredit = row?.credit;
      const rawDebit = row?.debit;
      const credit = rawCredit == null ? null : Number(rawCredit);
      const debit = rawDebit == null ? null : Number(rawDebit);
      const hasCredit = Number.isFinite(credit) && credit > 0;
      const hasDebit = Number.isFinite(debit) && debit > 0;
      const hasExplicitZeroValue = (Number.isFinite(credit) && credit === 0) || (Number.isFinite(debit) && debit === 0);
      let normalizedRewardValue = null;

      if (hasCredit) {
        normalizedRewardValue = credit;
      } else if (hasDebit) {
        normalizedRewardValue = -debit;
      } else if (hasExplicitZeroValue) {
        normalizedRewardValue = 0;
      }

      return {
        id: row?.id ?? null,
        reward_id: row?.reward_id ?? null,
        reference: row?.reference ?? null,
        i_customer: row?.i_customer ?? null,
        type: row?.type ?? null,
        status: row?.status ?? null,
        credit: row?.credit ?? null,
        debit: row?.debit ?? null,
        spend_requirement: row?.spend_requirement ?? null,
        spend_requirement_met: row?.spend_requirement_met ?? null,
        spend_check_date: row?.spend_check_date ?? null,
        allocated_at: row?.allocated_at ?? null,
        reward_source: row?.type ?? row?.reward_source ?? null,
        allocated_date: row?.allocated_at ?? row?.allocated_date ?? null,
        reward_value: normalizedRewardValue,
        expires_at: row?.expires_at ?? null,
        created_at: row?.created_at ?? null,
        updated_at: row?.updated_at ?? null,
      };
    });

    return {
      status_code: data.status_code,
      data: rewards,
      pagination: {
        total: meta?.total != null ? meta.total : rewards.length,
        perPage: meta?.perPage ?? per_page,
        page: meta?.page ?? page,
        lastPage: meta?.lastPage ?? 1,
      },
    };
  } catch (ex) {
    return createApiError(ex, "getCustomerRewards", { i_customer, page, per_page, status, reward_source });
  }
};

export const getCustomerTransactionHistory = async (i_customer, start_date, end_date, limit, page) => {
  try {
    let url = `${base_url}/app/customer/transactions?i_customer=${i_customer}&from_date=${format(new Date(start_date), "yyyy-MM-dd")}&to_date=${format(new Date(end_date), "yyyy-MM-dd")}`;
    if (limit != null && page != null) {
      url = `${base_url}/app/customer/transactions?i_customer=${i_customer}&from_date=${format(new Date(start_date), "yyyy-MM-dd")}&to_date=${format(new Date(end_date), "yyyy-MM-dd")}&limit=${limit}&page=${page}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getCustomerTransactionHistory");
  }
};

export const getWalletTransactionHistory = async (i_customer, start_date, end_date, limit, page) => {
  try {
    let url = `${base_url}/app/wallet/transactions?i_customer=${i_customer}&from_date=${format(new Date(start_date), "yyyy-MM-dd")}&to_date=${format(new Date(end_date), "yyyy-MM-dd")}`;
    if (limit != null && page != null) {
      url = `${base_url}/app/wallet/transactions?i_customer=${i_customer}&from_date=${format(new Date(start_date), "yyyy-MM-dd")}&to_date=${format(new Date(end_date), "yyyy-MM-dd")}&limit=${limit}&page=${page}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getWalletTransactionHistory");
  }
};

export const getSmsTransactionHistory = async (msisdn, start_date, end_date, limit, page, messageFilterName) => {
  try {
    let url = `${base_url}/app/customer/transactions/sms?msisdn=${msisdn}&from_date=${format(new Date(start_date), "yyyy-MM-dd")}&to_date=${format(new Date(end_date), "yyyy-MM-dd")}&message_text=${messageFilterName}`;
    if (limit != null && page != null) {
      url = `${base_url}/app/customer/transactions/sms?msisdn=${msisdn}&from_date=${format(new Date(start_date), "yyyy-MM-dd")}&to_date=${format(new Date(end_date), "yyyy-MM-dd")}&message_text=${messageFilterName}&limit=${limit}&page=${page}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getSmsTransactionHistory");
  }
};

export const listAllProducts = async () => {
  try {
    const url = `${base_url}/products`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllProducts");
  }
};

export const listAllProductsByGroup = async () => {
  try {
    const url = `${base_url}/product/expiryPeriod`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllProductsByGroup");
  }
};

export const listAllProductGroup = async () => {
  try {
    const url = `${base_url}/product/group`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllProductGroup");
  }
};

export const getProductDetails = async (id) => {
  try {
    const url = `${base_url}/product/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getProductDetails");
  }
};

export const updateProductGroupMapping = async (mappingData) => {
  try {
    const url = `${base_url}/product/productGroupProduct/modiify`;
    const { data } = await axiosAuthInstance.put(url, mappingData);
    return data;
  } catch (ex) {
    return createApiError(ex, "updateProductGroupMapping");
  }
};

export const getProductGroupDetails = async (id) => {
  try {
    const url = `${base_url}/product/group/details/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getProductGroupDetails");
  }
};

export const listAllProductTypes = async () => {
  try {
    const url = `${base_url}/product/types`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllProductTypes");
  }
};

export const updateProductStatus = async (statusData) => {
  try {
    const url = `${base_url}/product/updateStatus`;
    const { data } = await axiosAuthInstance.put(url, statusData);
    return data;
  } catch (ex) {
    return createApiError(ex, "updateProductStatus");
  }
};

export const updateProductGroupStatus = async (statusData) => {
  try {
    const url = `${base_url}/product/productGroup/updateStatus`;
    const { data } = await axiosAuthInstance.put(url, statusData);
    return data;
  } catch (ex) {
    return createApiError(ex, "updateProductGroupStatus");
  }
};

export const listAllEscalations = async (i_customer, status, start_date, end_date) => {
  try {
    const url = `${base_url}/escalation/get/distributor/${i_customer}`;
    const { data } = await axiosAuthInstance.post(url, { status, start_date, end_date });
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllEscalations");
  }
};

export const getEscalationDetails = async (id) => {
  try {
    const url = `${base_url}/escalation/get/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getEscalationDetails");
  }
};

export const createEscalation = async (msisdn, distributor_i_customer, app_user, title, description, files, iccid) => {
  const formDataPayload = new FormData();
  formDataPayload.append("msisdn", msisdn);
  formDataPayload.append("iccid", iccid);
  formDataPayload.append("distributor_i_customer", distributor_i_customer);
  formDataPayload.append("app_user", app_user);
  formDataPayload.append("title", title);
  formDataPayload.append("description", description);
  if (files.length) {
    files.forEach((file) => {
      formDataPayload.append("files", file);
    });
  }
  try {
    const url = `${base_url}/escalation/create`;
    const { data } = await axiosAuthInstanceForFormData.post(url, formDataPayload);
    return data;
  } catch (ex) {
    return createApiError(ex, "createEscalation");
  }
};

// export const uploadAttachments = async (payload) => {
//   try {
//     const formDataPayload = new FormData();
//     formDataPayload.append("files", payload.file);
//     const { data } = await axiosAuthInstanceForFormData.post("/escalation/upload-attachments", formDataPayload);
//     return data;
//   } catch (ex) {
//     return {
//       status_code: 500,
//       message: ex.message,
//     };
//   }
// };

export const getDistributorBalances = async (distributor_i_customer, refresh) => {
  try {
    const url = `${base_url}/app/distributor/balance`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, refresh });
    return data;
  } catch (ex) {
    return createApiError(ex, "getDistributorBalances");
  }
};
export const getSubDistributorBalances = async (distributor_i_customer, sub_distributor_id, refresh) => {
  try {
    const url = `${base_url}/app/subDistributor/promo-balance`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, sub_distributor_id, refresh });
    return data;
  } catch (ex) {
    return createApiError(ex, "getSubDistributorBalances");
  }
};
export const getDistributorPromoDataBalances = async (distributor_i_customer, refresh) => {
  try {
    const url = `${base_url}/app/distributor/promo-balance`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, refresh });
    return data;
  } catch (ex) {
    return createApiError(ex, "getDistributorPromoDataBalances");
  }
};

export const getRedirectSVIXURL = async (i_customer) => {
  try {
    const url = `${base_url}/app/svixportal/url?distributor_i_customer=${i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getRedirectSVIXURL");
  }
};

export const getBatchRequests = async (i_customer) => {
  try {
    const url = `${base_url}/app/subscription/batchRequest?distributor_i_customer=${i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getBatchRequests");
  }
};

export const getBatchDetails = async (batch_id) => {
  try {
    const url = `${base_url}/app/subscription/batchRequest/details?batch_request_id=${batch_id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getBatchDetails");
  }
};

export const listAllTrainingVideoCategories = async (category_name) => {
  try {
    const url = `${base_url}/trainingVideos/categories?type=${category_name}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllTrainingVideoCategories");
  }
};

export const listAllTrainingVideos = async (category_type, distributor_i_customer, role) => {
  try {
    const url = `${base_url}/trainingVideos/videos?category_type=${category_type}&distributor_i_customer=${distributor_i_customer}&role=${role}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllTrainingVideos");
  }
};

export const listAllVideos = async () => {
  try {
    const url = `${base_url}/trainingVideos/videos`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listAllVideos");
  }
};

export const uploadTrainingVideoDetails = async (name, description, link, categoryId, brand, files) => {
  const formDataPayload = new FormData();
  formDataPayload.append("name", name);
  formDataPayload.append("description", description);
  formDataPayload.append("link", link);
  formDataPayload.append("categoryId", categoryId);
  formDataPayload.append("thumbnail", files[0]);
  formDataPayload.append("brand", brand);
  try {
    const url = `${base_url}/trainingVideos/upload`;
    const { data } = await axiosAuthInstanceForFormData.post(url, formDataPayload);
    return data;
  } catch (ex) {
    return createApiError(ex, "uploadTrainingVideoDetails");
  }
};

export const editTrainingVideoDetails = async (id, name, description, link, categoryId, files, selectedBrand) => {
  const formDataPayload = new FormData();
  formDataPayload.append("id", id);
  formDataPayload.append("name", name);
  formDataPayload.append("description", description);
  formDataPayload.append("link", link);
  formDataPayload.append("categoryId", categoryId);
  formDataPayload.append("brand", selectedBrand);
  if (files) {
    formDataPayload.append("thumbnail", files[0]);
  }
  try {
    const url = `${base_url}/trainingVideos/update`;
    const { data } = await axiosAuthInstanceForFormData.put(url, formDataPayload);
    return data;
  } catch (ex) {
    return createApiError(ex, "editTrainingVideoDetails");
  }
};

export const deleteVideoDetails = async (id) => {
  try {
    const url = `${base_url}/trainingVideos/remove/${id}`;
    const { data } = await axiosAuthInstance.delete(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "deleteVideoDetails");
  }
};

export const getVideoDetails = async (id) => {
  try {
    const url = `${base_url}/trainingVideos/videos/details/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getVideoDetails");
  }
};

export const getMetabaseHQDashboardLink = async (role, i_customer, sub_distributor_id, group_id) => {
  try {
    const url = `${base_url}/app/reports/get-dashboard-link`;
    
    // Build request body conditionally - only include parameters that are not null/undefined
    const requestBody = { role };
    
    // Only include distributor_i_customer if it's not null/undefined (admin role doesn't need it)
    if (i_customer !== null && i_customer !== undefined) {
      requestBody.distributor_i_customer = i_customer;
    }
    
    // Only include sub_distributor_id if it's not null/undefined
    if (sub_distributor_id !== null && sub_distributor_id !== undefined) {
      requestBody.sub_distributor_id = sub_distributor_id;
    }
    
    // Only include group_id if it's not null/undefined
    if (group_id !== null && group_id !== undefined) {
      requestBody.group_id = group_id;
    }
    
    // Log request for debugging (remove in production if needed)
    logger.info("getMetabaseHQDashboardLink Request", {
      url,
      requestBody: JSON.stringify(requestBody),
      role,
      i_customer,
      sub_distributor_id,
      group_id,
    });
    
    const { data } = await axiosAuthInstance.post(url, requestBody);
    
    // Log response for debugging
    logger.info("getMetabaseHQDashboardLink Response", {
      status_code: data?.status_code,
      hasData: !!data?.data,
    });
    
    return data;
  } catch (ex) {
    return createApiError(ex, "getMetabaseHQDashboardLink");
  }
};

// Admin Dashboard - Metabase Integration (single embedded dashboard URL)
export const getAdminDashboardLink = async () => {
  try {
    const url = `${base_url}/app/reports/get-admin-dashboard-link`;
    
    // Create axios instance with admin API key header
    const adminConfig = {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': import.meta.env.VITE_ADMIN_API_KEY || ''
      }
    };
    
    const { data } = await axiosAuthInstance.post(url, {}, adminConfig);
    return data;
  } catch (ex) {
    // Handle specific error cases
    if (ex.response?.status === 401 || ex.response?.status === 403) {
      return { status_code: 9002, message: "Access denied - Admin privileges required" };
    }
    if (ex.code === 'NETWORK_ERROR' || ex.message?.includes('Network Error')) {
      return { status_code: 9003, message: "Unable to connect to server" };
    }

    return createApiError(ex, "getAdminDashboardLink");
  }
};

export const getRetailIncentiveDashboardLink = async (role, i_customer) => {
  try {
    const url = `${base_url}/app/reports/get-retail-incentive-link`;
    const { data } = await axiosAuthInstance.post(url, { role, distributor_i_customer: i_customer });
    return data;
  } catch (ex) {
    return createApiError(ex, "getRetailIncentiveDashboardLink");
  }
};

export const getSPARMobileRetailCommissionDashboardLink = async (role, distributor_i_customer, sub_distributor_id) => {
  try {
    const url = `${base_url}/app/reports/get-retail-commission-link`;
    const { data } = await axiosAuthInstance.post(url, { role, distributor_i_customer, sub_distributor_id });
    return data;
  } catch (ex) {
    return createApiError(ex, "getSPARMobileRetailCommissionDashboardLink");
  }
};

export const getPromoEngineDashboardLink = async (role, distributor_i_customer, sub_distributor_id = null) => {
  try {
    let url; let payload;
    
    if (role === "distributor") {
      url = `${base_url}/app/reports/get-hq-promo-data-link`;
      payload = { role, distributor_i_customer };
    } else if (role === "sub-distributor") {
      url = `${base_url}/app/reports/get-retail-promo-data-link`;
      payload = { role: "sub-distributor", distributor_i_customer, sub_distributor_id };
    } else {
      throw new Error(`Unsupported role: ${role}`);
    }
    
    const { data } = await axiosAuthInstance.post(url, payload);
    return data;
  } catch (ex) {
    return createApiError(ex, "getPromoEngineDashboardLink");
  }
};

export const getPromoEngineLedgerDashboardLink = async (role, distributor_i_customer, date) => {
  try {
    const url = `${base_url}/app/reports/get-hq-promo-data-ledger-link`;
    const payload = { role, distributor_i_customer, date };

    const { data } = await axiosAuthInstance.post(url, payload);
    return data;
  } catch (ex) {
    return createApiError(ex, "getPromoEngineLedgerDashboardLink");
  }
};

export const getCraveRewardsDashboardLink = async (role, distributor_i_customer, sub_distributor_id = null) => {
  try {
    const url = `${base_url}/app/reports/get-crave-rewards-link`;
    const payload = { role, distributor_i_customer, sub_distributor_id };
    
    const { data } = await axiosAuthInstance.post(url, payload);
    return data;
  } catch (ex) {
    return createApiError(ex, "getCraveRewardsDashboardLink");
  }
};

export const addLeveledSubDistributor = async (data) => {
  try {

    const url = `${base_url}/app/distributor/sub-distributors/add`;
    const { data: response } = await axiosAuthInstance.post(url, data);
    return response;
  } catch (ex) {
    return createApiError(ex, "addLeveledSubDistributor");
  }
};

export const getReferrerDistributors = async (i_customer) => {
  try {
    const url = `${base_url}/app/referrer-distributors?i_customer=${i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getReferrerDistributors");
  }
};

export const sellProduct = async ({ distributor_i_customer, msisdn, product_id, reference }) => {
  try {
    const url = `${base_url}/app/sellproduct`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, msisdn, product_id, reference });
    return data;
  } catch (ex) {
    return createApiError(ex, "sellProduct");
  }
};

export const sellAirtime = async ({ distributor_i_customer, msisdn, amount, reference }) => {
  try {
    const url = `${base_url}/app/sellairtime`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, msisdn, amount, reference });
    return data;
  } catch (ex) {
    return createApiError(ex, "sellAirtime");
  }
};

export const allocatePromoData = async ({ distributor_i_customer, msisdn, amount, reference }) => {
  try {
    const url = `${base_url}/app/distributor/promo/data`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, msisdn, amount, reference });
    return data;
  } catch (ex) {
    return createApiError(ex, "allocatePromoData");
  }
};

export const getMerchantAccounts = async (distributor_i_customer) => {
  try {
    const url = `${base_url}/app/distributor/merchant/accounts/?distributor_i_customer=${distributor_i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
    // [
    //   { label: 'The Shawshank Redemption', year: 1994 },
    //   { label: 'The Godfather', year: 1972 },
    //   { label: 'The Godfather: Part II', year: 1974 },
    //   { label: 'The Dark Knight', year: 2008 },
    //   { label: '12 Angry Men', year: 1957 },
    //   { label: "Schindler's List", year: 1993 },
    //   { label: 'Pulp Fiction', year: 1994 }];
  } catch (ex) {
    return createApiError(ex, "getMerchantAccounts");
  }
};

export const getWalletBatchRequests = async (distributor_i_customer, limit, page, searchText) => {
  try {
    let url = `${base_url}/app/wallet/batchRequest?distributor_i_customer=${distributor_i_customer}`;
    if (limit != null && page != null) {
      url += `&limit=${limit}&page=${page}`;
    }
    if (searchText) {
      url += `&searchText=${searchText}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getWalletBatchRequests");
  }
};

export const getWalletBatchDetails = async (batch_request_id, limit, page) => {
  try {
    let url = `${base_url}/app/wallet/batchRequest/${batch_request_id}`;
    if (limit != null && page != null) {
      url += `?limit=${limit}&page=${page}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getWalletBatchDetails");
  }
};

export const getWalletMerchantAccountDetailsWithBalance = async (distributor_i_customer, limit, page) => {
  try {
    let url = `${base_url}/app/distributor/merchant/accounts/balances?distributor_i_customer=${distributor_i_customer}`;
    if (limit != null && page != null) {
      url += `&limit=${limit}&page=${page}`;
    }
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getWalletMerchantAccountDetailsWithBalance");
  }
};

export const getWalletMerchantAccountHistory = async (distributor_i_customer, wallet_account_number, start_date, end_date, limit, page) => {
  try {
    let url = `${base_url}/app/distributor/merchant/accounts/transactions?distributor_i_customer=${distributor_i_customer}&wallet_account_number=${wallet_account_number}&start_date=${format(new Date(start_date), "yyyy-MM-dd")}&end_date=${format(new Date(end_date), "yyyy-MM-dd")}`;
    if (limit != null && page != null) {
      url += `&limit=${limit}&page=${page}`;
    }
    const { data } = await axiosAuthInstance.get(url);

    return data;
  } catch (ex) {
    return createApiError(ex, "getWalletMerchantAccountHistory");
  }
};

export const downloadBatchRequestDetailsList = async (batch_request_id, email_address) => {
  try {
    const url = `${base_url}/app/wallet/batchRequest/download/${batch_request_id}?email_address=${email_address}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "downloadBatchRequestDetailsList");
  }
};

export const distributorBalanceTopup = async (distributor_i_customer, email_address, amount) => {
  try {
    const url = `${base_url}/app/distributor/top_up`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, email_address, amount });
    return data;
  } catch (ex) {
    return createApiError(ex, "distributorBalanceTopup");
  }
};

export const fetchPromoProductsData = async (distributor_i_customer, sub_distributor_id) => {
  try {
    const url = `${base_url}/app/distributor/promo-data-product?distributor_i_customer=${distributor_i_customer}&sub_distributor_id=${sub_distributor_id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "fetchPromoProductsData");
  }
};

export const fetchBrandPromoProductsData = async (distributor_i_customer, sub_distributor_id) => {
  try {
    const url = `${base_url}/app/distributor/brand-promo-data-product?distributor_i_customer=${distributor_i_customer}&sub_distributor_id=${sub_distributor_id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "fetchBrandPromoProductsData");
  }
};

export const promoDataTopup = async (distributor_i_customer, email_address, product_id, app_user_role_id = null) => {
  try {
    const url = `${base_url}/app/distributor/promo_data_invoice`;
    const body = { distributor_i_customer, email_address, product_id };
    if (app_user_role_id) body.app_user_role_id = app_user_role_id;
    const { data } = await axiosAuthInstance.post(url, body);
    return data;
  } catch (ex) {
    return createApiError(ex, "promoDataTopup");
  }
};

export const subDistributorPromoDataTopup = async (
  distributor_i_customer,
  sub_distributor_id,
  email_address,
  product_id,
  app_user_role_id = null
) => {
  try {
    const url = `${base_url}/app/distributor/sub_distributor_promo_data_invoice`;
    const body = { distributor_i_customer, sub_distributor_id, email_address, product_id };
    if (app_user_role_id) body.app_user_role_id = app_user_role_id;
    const { data } = await axiosAuthInstance.post(url, body);
    return data;
  } catch (ex) {
    return createApiError(ex, "subDistributorPromoDataTopup");
  }
};

export const smsCreditsTopup = async (distributor_i_customer, email_address, credits) => {
  try {
    const url = `${base_url}/app/distributor/invoice/wholesale_sms_credits`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, email_address, credits });
    return data;
  } catch (ex) {
    return createApiError(ex, "smsCreditsTopup");
  }
};

export const getBankCode = async () => {
  try {
    const url = `${base_url}/app/distributor/bank-code`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getBankCode");
  }
};

export const getMerchantBeneficiaryList = async (wallet_account_number, i_customer) => {
  try {
    const url = `${base_url}/app/distributor/merchant/accounts/recipients?wallet_account_number=${wallet_account_number}&distributor_i_customer=${i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getMerchantBeneficiaryList");
  }
};

export const downloadTransactionHistory = async (wallet_account_number, email_address, distributor_i_customer) => {
  try {
    const url = `${base_url}/app/distributor/merchant/accounts/transactions/export?wallet_account_number=${wallet_account_number}&email_address=${email_address}&distributor_i_customer=${distributor_i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "downloadTransactionHistory");
  }
};

export const getAccountStatement = async (wallet_account_number, start_date, end_date) => {
  try {
    // const url = `${base_url}/app/distributor/merchant/accounts/transactions/export?wallet_account_number=${wallet_account_number}&email_address=${email_address}&distributor_i_customer=${distributor_i_customer}`;
    const url = `${base_url}/app/distributor/TEST_URL_REPLACE_WITH_REAL?wallet_account_number=${wallet_account_number}&start_date=${start_date}&end_date=${end_date}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getAccountStatement");
  }
};

export const addRecipients = async (recipients_data) => {
  try {
    const url = `${base_url}/app/distributor/merchant/accounts/recipients/add`;
    const { data } = await axiosAuthInstance.post(url, recipients_data);
    return data;
  } catch (ex) {
    return createApiError(ex, "addRecipients");
  }
};

export const payRecipients = async (pay_data) => {
  try {
    const url = `${base_url}/app/distributor/merchant/accounts/recipients/pay`;
    const { data } = await axiosAuthInstance.post(url, pay_data);
    return data;
  } catch (ex) {
    return createApiError(ex, "payRecipients");
  }
};

export const acceptTermsHandle = async (terms_and_conditions_name, username) => {
  try {
    const url = `${base_url}/app/customer/accept-terms-conditions`;
    const { data } = await axiosAuthInstance.post(url, { terms_and_conditions_name, username });
    return data;
  } catch (ex) {
    return createApiError(ex, "acceptTermsHandle");
  }
};

export const logoutAppUser = async () => {
  try {
    const url = `${base_url}/app/logout`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "logoutAppUser");
  }
};

// --SPAR--

export const acceptSPARTermsHandle = async (spar_terms_and_conditions_name, username) => {
  try {
    const url = `${base_url}/app/customer/accept-spar-terms-conditions`;
    const { data } = await axiosAuthInstance.post(url, { spar_terms_and_conditions_name, username });
    return data;
  } catch (ex) {
    return createApiError(ex, "acceptSPARTermsHandle");
  }
};

export const subDistributorPromoDataRequest = async ({ distributor_i_customer, sub_distributor_id, amount }) => {
  try {
    const url = `${base_url}/app/promo-data/request`;
    const { data } = await axiosAuthInstance.post(url, { distributor_i_customer, sub_distributor_id, amount });
    return data;
  } catch (ex) {
    return createApiError(ex, "subDistributorPromoDataRequest");
  }
};

export const getSubDistributorAgreements = async (distributor_i_customer) => {
  try {
    const url = `${base_url}/app/spar/sub-distributors?distributor_i_customer=${distributor_i_customer}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getSubDistributorAgreements");
  }
};

export const activateSubDistributorData = async (sub_distributor_id) => {
  try {
    const url = `${base_url}/app/spar/accept-sub-distributor-agreement`;
    const { data } = await axiosAuthInstance.post(url, { sub_distributor_id });
    return data;
  } catch (ex) {
    return createApiError(ex, "activateSubDistributorData");
  }
};

export const getWalletMerchantAccountStatements = async (distributor_i_customer, wallet_account_number) => {
  try {
    const url = `${base_url}/app/distributor/merchant/statements/get?distributor_i_customer=${distributor_i_customer}&wallet_account_number=${wallet_account_number}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getWalletMerchantAccountStatements");
  }
}

export const submitMerchantAccountStatement = async(distributor_id, start_date, end_date, wallet_account_number) => {
  try {
    let url = `${base_url}/app/distributor/merchant/statements/add?`;
    url += `distributor_i_customer=${distributor_id}`;
    url += `&start_date=${start_date}`;
    url += `&end_date=${end_date}`;
    url += `&wallet_account_number=${wallet_account_number}`;
    const {data} = await axiosAuthInstance.post(url, {
      distributor_i_customer: distributor_id,
      start_date,
      end_date,
      wallet_account_number
    });
    return data;
  } catch (ex) {
    return createApiError(ex, "submitMerchantAccountStatement");
  }
}

export const emailMerchantStatement = async(distributor_i_customer, distributor_merchant_statement_id, app_user_id) => {
  try {
    const url = `${base_url}/app/distributor/merchant/statements/email`;
    const data = await axiosAuthInstance.post(url, {
      distributor_i_customer,
      distributor_merchant_statement_id,
      app_user_id
    });
    return data;
  } catch (ex) {
    return createApiError(ex, "emailMerchantStatement");
  }
}

export const createXeroContact = async (
  accountNumber,
  companyName,
  companyNumber,
  taxNumber,
  defaultCurrency,
  addresses,
  phones,
  firstName,
  lastName,
  emailAddress,
  contactPersons,
  bankAccountDetails,
  IsCustomer,
  IsSupplier,
  distributor_i_customer,
  sub_distributor_id
) => {
  try {
    /*

    {
    "status_code": 1001,
    "data": {
        "accountNumber": "4562",
        "companyName": "Test Company",
        "companyNumber": "098098",
        "taxNumber": "987987987",
        "addresses": [
            {
                "addressType": "Street",
                "addressLine1": "16 Golden Hind",
                "addressLine2": "140 Church Street",
                "addressLine3": null,
                "addressLine4": null,
                "city": "Hermanus",
                "region": "Western Cape",
                "postalCode": "7200",
                "country": "ZA",
                "attentionTo": null
            }
        ],
        "phones": [
            {
                "phoneType": "Default",
                "phoneNumber": "27639010416"
            }
        ],
        "firstName": "Neil",
        "lastName": "Feris",
        "emailAddress": "neil@megsapp.com",
        "contactPersons": null
    }
}

    */
    const { data } = await axiosAuthInstance.post('/xero/contact', {
      accountNumber: accountNumber.toString(),
      companyName,
      companyNumber,
      taxNumber,
      defaultCurrency,
      addresses,
      phones,
      firstName,
      lastName,
      emailAddress,
      contactPersons,
      bankAccountDetails,
      IsCustomer,
      IsSupplier,
      distributor_i_customer,
      sub_distributor_id
    });
    logger.info("Xero contact created successfully", {
      accountNumber,
      companyName,
      distributor_i_customer,
      sub_distributor_id
    });
    return data;
  } catch (ex) {
    return createApiError(ex, "createXeroContact", { accountNumber, companyName, distributor_i_customer });
  }
};
